import React, { Component } from 'react';
import saveAs from 'file-saver';
import _ from 'lodash';
import QueryView from './QueryTabView';
import DateFormatter from '../../utils/DateFormatter';
import percent from '../../utils/percent';
import Button from '../../views/StyledButton';
import queryTabStore from './queryTabStore';
import {
  eventToNumber, eventToBoolean, eventToString, eventToObject,
}
  from '../../utils/eventExtraction';

const API_URL = process.env.API_URL; // eslint-disable-line
const { PLAYER_URL } = process.env;
const BOUND_FUNCTIONS = _([
  'goHome',
  'downloadQuery',
  'doUpdateQueryName',
  'doRemoveQuery',
])
  .uniq()
  .compact()
  .value();

export default class QueryTabContainer extends Component {
  constructor(props) {
    super(props);
    this.store = queryTabStore(props);
    this.state = {
      ...this.store.state,
      schema: props.schema,
    };

    BOUND_FUNCTIONS.forEach((fn) => {
      if (this[fn] && _.isFunction(this[fn])) {
        this[fn] = this[fn].bind(this);
      } else {
        console.log('cannot find function ', fn);
      }
    });

    const { name, query, category } = props;

    if (query) {
      this.store.actions.chooseQuery(query);
    }
    if (name) {
      this.store.actions.setQueryName(name);
    }
    this.store.actions.setToken(_.get(props, 'ephemeralKey.bearerToken'));
  }

  static getDerivedStateFromProps(props, state) {
    if (props.schema !== state.schema) {
      return { ...state, schema: props.schema };
    }
    return state;
  }

  goHome() {
    this.props.history.push('/');
  }

  componentDidUpdate() {
    // console.log('--- QueryTabContainer', this.state.queryName, 'updated with state ', this.state);
  }

  async downloadQuery() {
    const date = new Date();
    const { store } = this;
    // eslint-disable-next-line prefer-const
    if (typeof Blob === 'undefined') {
      alert('cannot save query. sorry.');
      return;
    }
    // eslint-disable-next-line prefer-const
    let { queryName, queryModel } = store.state;
    if (!queryName) {
      queryName = `query ${Math.random()}`;
    }
    const json = {
      query: queryModel.query,
      composed: queryModel.composed(),
      saved: date.toISOString(),
      name: queryName,
    };

    let file;
    try {
      file = new Blob([JSON.stringify(json)], { type: 'application/json;charset=utf-8' });
    } catch (err) {
      console.log('error converting file', err);
      alert(`cannot save file:${err.message}`);
      return;
    }

    await this.store.actions.setUploading(true);
    saveAs(file, `${queryName} # ${DateFormatter.formatForFile(new Date())}.json`);
    this.store.actions.setUploading(false);
    this.store.actions.setQueryName('');
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this._stateSub) {
      this._stateSub.unsubscribe();
    }
  }

  /**
   * sets state if the component has not been unmounted.
   * returns a promise tied into setState (or auto-completes if no set state call)
   * @param change
   * @param onDone
   * @returns {Promise<any>}
   */
  setStateSafely(change, onDone) {
    return new Promise((done) => {
      if (!this.unmounted) {
        this.setState(change, () => {
          if (_.isFunction(onDone)) {
            onDone();
          }
          done();
        });
      } else {
        done();
      }
    });
  }

  onUpload(json) {
    const { store } = this;

    console.log('onUpload received', json);
    const query = _.get(json, 'query');
    const queryName = _.get(json, 'name');
    console.log('uploaded ', query, queryName, json);
    if (query) {
      store.actions.chooseQuery(query || '');
      if (queryName) {
        this.doUpdateQueryName(queryName || '');
      }
    } else {
      alert('cannot parse query file: no query field');
    }
  }

  uploadProps() {
    const { store } = this;
    const beforeUpload = () => {
      store.actions.setUploading(true);
    };

    // onLoad is a factory function that returns a function with reader in closure.
    const onLoad = (reader) => () => {
      const data = reader.result;
      store.actions.setUploading(true).then(() => {
        const str = data.toString();
        try {
          const json = JSON.parse(str);
          if (!this.state.composing) {
            this.onUpload(json);
          }
        } catch (err) {
          window.alert(`cannot parse query file${err.message}`); // @TODO: better error dialogs
        }
        store.actions.setUploading(false);
      });
    };

    return {
      beforeUpload: () => {
        beforeUpload();
        return false;
      },
      showUploadList: false,
      accept: '.json',
      onChange(info) {
        const reader = new FileReader();
        reader.onload = onLoad(reader);
        reader.readAsText(info.file);
      },
    };
  }

  componentDidMount() {
    this._stateSub = this.store
      .subscribe((store) => {
        this.setState((state) => ({ ...state, ...store.state }));
      }, (err) => {
        console.log('error on store: ', err);
        this.store.restart();
      }, () => {
        console.log('end of subscribe');
      });
  }

  doUpdateQueryName(event) {
    const name = eventToString(event);
    this.store.actions.chooseQueryName(name);
    this.props.updateQueryName(name);
  }

  doRemoveQuery() {
    console.log('removing query', this.props);
    this.props.removeQuery(this.props);
  }

  changeEditMode(e) {
    const { actions } = this.store;
    const mode = eventToString(e);
    actions.chooseTab(mode);
  }


  render() {
    const { state, actions } = this.store;
    const { activateObjDialog, showMedia } = this.props;
    return (
      <QueryView
        pQuery={this.props.query}
        pCategory={this.props.category}
        goHome={this.goHome}
        uploadProps={this.uploadProps()}
        downloadQuery={this.downloadQuery}
        doUpdateQueryName={this.doUpdateQueryName}
        removeQuery={this.doRemoveQuery}
        changeEditMode={this.changeEditMode.bind(this)}
        activateObjDialog={activateObjDialog}
        showMedia={showMedia}
        {...this.state}
        {...state}
        {...actions}
      />
    );
  }
}
